const INTERVAL_DAY = 'day';
const INTERVAL_WEEK = 'week';
const INTERVAL_MONTH = 'month';
const INTERVAL_YEAR = 'year';
const INTERVAL_ALL_TIME = 'all-time';
const INTERVAL_CUSTOM = 'custom';
const INTERVALS = [
  {
    id: INTERVAL_DAY,
    name: '1 day',
  },
  {
    id: INTERVAL_WEEK,
    name: 'Week',
  },
  {
    id: INTERVAL_MONTH,
    name: 'Month',
  },
  {
    id: INTERVAL_YEAR,
    name: 'Year',
  },
  {
    id: INTERVAL_ALL_TIME,
    name: 'All time',
  },
  {
    id: INTERVAL_CUSTOM,
    name: 'Custom',
    disabled: true
  },
];

module.exports = {
  INTERVALS,
  INTERVAL_DAY,
  INTERVAL_WEEK,
  INTERVAL_MONTH,
  INTERVAL_YEAR,
  INTERVAL_ALL_TIME,
  INTERVAL_CUSTOM
};
